import { ITrafficSituation } from '../../../../../models/traffic-situation.model';
import { TranslationService } from '../../../../../services/translation.service';
import { IconMotif } from '../../Icon/icon-motif.enum';
import Fact from '../Fact';

export default function AlternativesFact({ trafficSituation, className = '' }: { trafficSituation: ITrafficSituation; className?: string }): React.ReactNode | null {
  if (!trafficSituation || !trafficSituation.aiGeneratedInformation || !trafficSituation.aiGeneratedInformation.alternatives) return null;

  return (
    <Fact
      iconMotif={IconMotif.Alternatives}
      className={className}
      altText={TranslationService.get('common.trafficsituation.alternatives')}
      title={TranslationService.get('common.trafficsituation.alternatives')}
    >
      <span>{trafficSituation.aiGeneratedInformation.alternatives}</span>
    </Fact>
  );
}
